/**
 * 📋 SDLC 6.3.1 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ===============================================================================
 * FILE: frontend/src/pages/landing/components/CTASection.tsx
 * PURPOSE: CTA Section - Final call-to-action with coffee gradient background
 * SDLC FRAMEWORK VERSION: 6.1.1 (7-Pillar + 3-Section + Long-Running Agent Protocol)
 * PILLAR: P1 (Stage 06 - BUILD) + P6 (UI/UX Design)
 * SPRINT GOVERNANCE: Rule 4: Tier-3 Code Review
 *
 * DATE: 2025-12-28
 * COMPLIANCE: SDLC 6.3.1 + NQH Brand Design System V2.0
 *
 * @cross-references
 * - Design: docs/02-design/04-ui-ux-design/LOGIN-LANDING-REDESIGN-DESIGN.md
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./CTASection.module.css";

export const CTASection: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.cta}>
      <div className={styles.content}>
        <div className={styles.icon}>☕</div>
        <h2 className={styles.headline}>{t("landing.cta.headline")}</h2>
        <p className={styles.subheadline}>{t("landing.cta.subheadline")}</p>

        <div className={styles.buttons}>
          <button
            type="button"
            className={styles.ctaPrimary}
            onClick={() => navigate("/login")}
          >
            {t("landing.cta.ctaPrimary")}
          </button>
          <button
            type="button"
            className={styles.ctaSecondary}
            onClick={() => window.location.href = "mailto:contact@nqh.com.vn"}
          >
            {t("landing.cta.ctaSecondary")}
          </button>
        </div>
      </div>
    </div>
  );
};
